/**
 * ReferralDashboardScreen — adaptateur primaire du tableau de parrainage (`referrer/dashboard`).
 *
 * Fil : données + view-model + gestes → la page du DS.
 *
 * Deux routes montent le même écran. Le cœur du header parent ouvre `referrer/dashboard` **avec le
 * hash du parent lui-même** (`ParentShellHeader.tsx:60`, `ParentTabHeader.js:105-117`) ; le
 * back-office pousse `referrer/dashboard/:h` sur la fiche de quelqu'un d'autre
 * (`ReferralsBackofficeScreen.js:44`). C'est donc la route, jamais la présence du hash, qui dit si
 * l'identité du parrain a un sens à l'écran.
 */
import { useSelector } from "react-redux"

import { ReferralDashboardPage } from "../../../../../../design-system"
import { referralDashboardViewModel } from "../../../../view-models/parent/Referral/referralDashboardViewModel"
import { useReferralDashboardData } from "./useReferralDashboardData"
import { useReferralDashboardState } from "./useReferralDashboardState"

/** La route du back-office — celle qui regarde la fiche d'un parrain, et la seule à la nommer. */
const REFERRER_DASHBOARD_BY_LINK = "referrer/dashboard/:h"

export type ReferralDashboardScreenProps = {
    route?: { name?: string; params?: { h?: string } | null } | null
}

export function ReferralDashboardScreen(props: ReferralDashboardScreenProps) {
    const hash = props.route?.params?.h ?? null
    const showReferrerIdentity = props.route?.name === REFERRER_DASHBOARD_BY_LINK

    const data = useReferralDashboardData(hash)
    const vm = useSelector((state: unknown) =>
        referralDashboardViewModel(state, data.raw, { hash, showReferrerIdentity })
    )
    const actions = useReferralDashboardState({ referralCode: data.raw })

    return (
        <ReferralDashboardPage
            dashboard={vm.dashboard}
            referrerLabel={vm.referrerLabel}
            shareActions={actions.shareActions}
            onCopyLink={actions.onCopyLink}
            shareErrorMessage={actions.shareErrorMessage}
            onToggleTerms={actions.onToggleTerms}
            onClose={actions.close}
            loading={data.loading}
            error={vm.error}
            onRetry={data.retry}
        />
    )
}

export default ReferralDashboardScreen
